import { siteInfo } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-lg font-bold">
                  <i className="ri-fire-fill"></i>
                </span>
                <span className="font-heading text-lg">{siteInfo.name}</span>
              </div>
              <p className="text-sm text-foreground-200 leading-relaxed mb-4 max-w-md">
                吃瓜网站线路一汇聚51吃瓜在线观看、吃瓜视频在线看等海量视频资源，免费吃瓜视频每日更新，黑料视频在线即时播放，做你身边最懂吃瓜的互联网伙伴。
              </p>
              <div className="flex items-center gap-3">
                <a href="#hero" className="w-8 h-8 flex items-center justify-center bg-foreground-800 text-foreground-300 rounded-full text-sm hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center bg-foreground-800 text-foreground-300 rounded-full text-sm hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center bg-foreground-800 text-foreground-300 rounded-full text-sm hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer no-underline">
                  <i className="ri-video-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-medium text-background-50 mb-4">快速导航</h3>
              <div className="flex flex-col gap-2">
                <a href="#updates" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">最新动向</a>
                <a href="#ranking" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">热搜榜单</a>
                <a href="#media" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">热门视频</a>
                <a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">深度好文</a>
                <a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline">常见问题</a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-medium text-background-50 mb-4">合作伙伴</h3>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-foreground-400">更多合作伙伴即将入驻</span>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; 2026 {siteInfo.name}. 本站内容仅供娱乐参考，不构成任何投资或法律建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">用户协议</a>
              <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">隐私政策</a>
              <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer no-underline">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}